<template>
    <div class="layout-profile">
        <!-- <div>
            <img src="assets/layout/images/profile.png" alt="" />
        </div> -->
        <span class="tipoUsuario">{{ tipoUsuario }}</span>
        <span class="nombre">{{ usuarioActual?.nombre }} {{ usuarioActual?.apellido }}</span> <br />
        <span class="username">({{ usuarioActual?.usuario }})</span> <br />
        <button class="p-link layout-profile-link" @click="onUserSettingsClick">
            <i class="pi pi-fw pi-cog"></i>
        </button>
        <transition name="layout-submenu-wrapper">
            <ul v-show="expanded">
                <li>
                    <!-- <router-link to="/miCuenta">
                        <button class="p-link"><i class="pi pi-fw pi-user"></i><span>Mi Cuenta</span></button>
                    </router-link> -->
                </li>
                <!-- <li>
                    <button class="p-link"><i class="pi pi-fw pi-inbox"></i><span>Notifications</span><span class="menuitem-badge">2</span></button>
                </li> -->
                <li>
                    <button class="p-link" @click="logout"><i class="pi pi-fw pi-power-off"></i><span>Cerrar Sesión</span></button>
                </li>
            </ul>
        </transition>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            expanded: false,
        };
    },
    mounted() {
    },
    methods: {
        onUserSettingsClick(event) {
            this.expanded = !this.expanded;
            event.preventDefault();
        },
        logout: function () {
            this.$store.dispatch("auth/logout");
            this.$router.push("/");
        },
    },
    computed: {
        ...mapGetters("auth", ["usuarioActual"]),
        tipoUsuario: function () {
            switch (this.usuarioActual.nivel) {
                case 1:
                    return "SuperAdmin";
                case 2:
                    return "Admin";
                case 3:
                    return "Manager";
                case 4:
                    return "Proveedor";
                case 5:
                    return "Usuario";
                default:
                    return "";
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.username {
    color: white;
    width: 80%;
    text-align: center;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 15px;
}
.nombre {
    color: white;
    width: 80%;
    text-align: center;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.tipoUsuario {
    width: 80%;
    text-align: center;
    display: inline-block;
    font-weight: bold;
    color: #e40948;
    margin-bottom: 12px;
    font-size: 18px;
}
</style>